<template>
  <div class="body-2 notice">
    <span v-if="userCupNotice"
      >{{$t('gameLegal.usercup')}}
      <br />
    </span>
    {{$t('gameLegal.default')}}
  </div>
</template>

<script>
export default {
  name: "GameLegal",
  props: {
    userCupNotice: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
